import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import Diary from './Diary';
import AddDiary from './AddDiary';

import { getDiaries } from '../../../../Actions/Dashboard/diary';
import { pingLogin } from '../../../../Actions/Dashboard/login';
import api from '../../../../lib/api';

class Diaries extends React.Component {
  componentDidMount() {
    this.props.dispatch(getDiaries());
    if (this.props.login) {
      api.setToken(this.props.login);
      this.props.dispatch(pingLogin(this.props.login.access_token, this.props.login.refresh_token));
    }
  }

  render() {
    return (
      <ul className="cb-blog_listing cb-blog_listing__tools">
        {this.props.diaries.map(diary => (
          <Diary diary={diary} key={diary.id} />
        ))}

        <AddDiary />
      </ul>
    );
  }
}

Diaries.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

export default connect(
  state => ({
    diaries: state.diaries,
    login: state.login,
  }),
  dispatch => ({ dispatch }),
)(Diaries);



// WEBPACK FOOTER //
// ./src/Components/Dashboard/Pages/Diary/List.jsx